export * from 'server/models/Barge';


// WEBPACK FOOTER //
// ./data/models/Barge.ts